/**
 * Implements a tokens list item component
 */
import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { IWalletOverviewToken } from '@kattana-io/common';

import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import NumberDisplay from '../../../molecules/NumberDisplay';

import fallbackIcon from '../../../molecules/PairIcons/icons/placeholder.svg';

const LIST_ITEM_GAPS_ICON_WIDTH = 60;

interface ITokenItemProps {
  token: IWalletOverviewToken;
  style: any;
  disabled: boolean;
  chain?: string;
}

const TokenItem = ({ token, style, chain, disabled }: ITokenItemProps) => {
  const [src, setSrc] = useState(token.Logo);
  const [width, setWidth] = useState<number>();
  const ref = useCallback((node: HTMLDivElement) => {
    if (node !== null) {
      setWidth(node.offsetWidth);
    }
  }, []);

  // used to determine wether show '...' for token name and symbol or not
  const tokenNameAllowedWidth = `calc(100% - ${width}px - ${LIST_ITEM_GAPS_ICON_WIDTH}px)`;

  return (
    <Link
      to={`/en/token/${chain}/${token.Address}`}
      className={`tokens__list__items__item ${
        disabled ? 'tokens__list__items__item--disabled' : ''
      }`}
      style={style}
    >
      <div className='tokens__list__items__item__image'>
        <Image
          src={src}
          size='l'
          alt={token.TokenSymbol}
          onError={() => setSrc(fallbackIcon)}
        />
      </div>
      <div
        className='tokens__list__items__item__description'
        style={{ maxWidth: tokenNameAllowedWidth }}
      >
        <Text size={14} style={{ title: token.TokenName }}>
          {token.TokenName}
        </Text>
        <Text size={10} style={{ title: token.TokenSymbol }}>
          {token.TokenSymbol}
        </Text>
      </div>
      <div className='tokens__list__items__item__separator' />
      <div className='tokens__list__items__item__amount' ref={ref}>
        <Text size={16} className='text--grey-200'>
          <NumberDisplay value={Number(token.Balance)} round={2} string />
          &nbsp;~
          <NumberDisplay
            value={Number(token.BalanceUSD)}
            round={2}
            startSymbol='$'
            string
          />
        </Text>
      </div>
    </Link>
  );
};

export default TokenItem;
